import { Modal } from "components/designV2/modal/modal";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { useTranslation } from "react-i18next";

interface ProfilePanelDeleteFutureEmploymentModalProps {
  isOpen: boolean;
  isDeletingEmployment: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ProfilePanelDeleteFutureEmploymentModal = (
  props: ProfilePanelDeleteFutureEmploymentModalProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      label={t("Staff.ProfilePanelDeleteFutureEmploymentConfirmTitle")}
      size="compact"
      showCloseButton={false}
      footer={
        <>
          <SecondaryButton
            label={t("General.Cancel")}
            disabled={props.isDeletingEmployment}
            onClick={props.onClose}
          />
          <SecondaryButton
            label={t("General.Delete")}
            iconName="v2/trash"
            isLoading={props.isDeletingEmployment}
            disabled={props.isDeletingEmployment}
            onClick={props.onConfirm}
            styleOverrides={{
              textColor: ColorV2.NegativeRed,
              borderColor: ColorV2.NegativeRed,
              iconColor: ColorV2.NegativeRed,
              hoverBackgroundColor: "#fce9e9",
              activeBackgroundColor: "rgba(211, 78, 78, 0.2)",
            }}
          />
        </>
      }
    >
      <Text typography="b2" color={ColorV2.Blue1} align="left">
        {t("Staff.ProfilePanelDeleteFutureEmploymentConfirmBody")}
      </Text>
    </Modal>
  );
};
